/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */


import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
    // auth: {
    //     clientId: environment.client_sso.cozentus.sso.adClientId,
    //     authority: 'https://login.microsoftonline.com/'+environment.client_sso.cozentus.sso.adTenantId,
    //     redirectUri: '/user/search/document-grid',
    //     postLogoutRedirectUri:'/login',
    //     navigateToLoginRequestUrl: false
    // },
    auth: {
        clientId: environment.client_sso.bridgenet.sso.adClientId,
        authority: 'https://login.microsoftonline.com/'+environment.client_sso.bridgenet.sso.adTenantId,
        redirectUri: '/user/search/document-grid',
        postLogoutRedirectUri:'/login',
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
            },
            logLevel: LogLevel.Verbose
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = new Map(
[
    // ["http://192.168.1.197:8899/",["e750ec39-3720-406b-b20c-0aa0005c56a1/api-access"]],
    // ["https://freight-audit-api-dev.azurewebsites.net/",["e750ec39-3720-406b-b20c-0aa0005c56a1/api-access"]],
    // ["https://freight-audit-api-test.azurewebsites.net/",["e750ec39-3720-406b-b20c-0aa0005c56a1/api-access"]],
    // ["https://graph.microsoft.com/v1.0/me",["https://graph.microsoft.com/User.Read"]]

    ["http://192.168.1.197:8899/",["8144c81a-963c-49bc-87a7-105662741a73/api-access"]],
    ["https://freight-audit-api-dev.azurewebsites.net/",["8144c81a-963c-49bc-87a7-105662741a73/api-access"]],
    ["https://freight-audit-api-test.azurewebsites.net/",["8144c81a-963c-49bc-87a7-105662741a73/api-access"]],
    ["https://graph.microsoft.com/v1.0/me",["https://graph.microsoft.com/User.Read"]]
]);

/*
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: environment.client_sso.cozentus.msalLogInRequest
    scopes: environment.client_sso.bridgenet.msalLogInRequest
};


// Will see this later in POC
export const bridgenetMsalConfig: Configuration = {
    auth: {
        clientId: environment.client_sso.bridgenet.sso.adClientId,
        authority: 'https://login.microsoftonline.com/'+environment.client_sso.bridgenet.sso.adTenantId,
        redirectUri: '/user/search/application',
        postLogoutRedirectUri:'/login',
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
            },
            logLevel: LogLevel.Verbose
        }
    }
};

export const bridgenetLoginRequest = {
    scopes: environment.client_sso.bridgenet.msalLogInRequest
};